import script from "./live.vue?vue&type=script&setup=true&lang=js"
export * from "./live.vue?vue&type=script&setup=true&lang=js"

import "./live.vue?vue&type=style&index=0&id=c3421a28&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3421a28"]])

export default __exports__